<template>
  <div>
    <g-signin-button
      v-if="!disabled"
      :params="googleSignInParams"
      @success="onSignInSuccess"
      @error="onSignInError">
      <div class="google-login-btn">
        <img src="/static/svg/icon-text-google.svg">
        {{ text }}
      </div>
    </g-signin-button>
    <div
      v-else
      class="google-login-btn google-login-btn--disabled"
    >
      <img src="/static/svg/icon-text-google.svg">
      {{ text }}
    </div>
  </div>
</template>

<script>
import { GOOGLE_CLIENT_ID } from '@/constants'

export default {
  name: 'GoogleLoginButton',
  props: {
    text: {
      type: String,
      default: 'Login with Google'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      /**
       * The Auth2 parameters, as seen on
       * https://developers.google.com/identity/sign-in/web/reference#gapiauth2initparams.
       * As the very least, a valid client_id must present.
       * @type {Object}
       */
      googleSignInParams: {
        client_id: GOOGLE_CLIENT_ID
      }
    }
  },
  methods: {
    onSignInSuccess (googleUser) {
      // `googleUser` is the GoogleUser object that represents the just-signed-in user.
      // See https://developers.google.com/identity/sign-in/web/reference#users
      // const profile = googleUser.getBasicProfile() // etc etc
      if (!this.disabled) {
        this.$emit('onSignInSuccess', googleUser)
      }
    },
    onSignInError (error) {
      // `error` contains any error occurred.
      if (!this.disabled) {
        this.$emit('onSignInError', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.google-login-btn {
  background-color: #dd4b39;
  color: #fff;
  padding: 12px 19px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 5px;
  margin-bottom: 20px;
  cursor: pointer;
  text-align: left;

  &--disabled {
    background-color: #b3b3b3;
    cursor: not-allowed;
  }
}
.google-login-btn img {
  vertical-align: middle;
  margin-right: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/GoogleLoginButton.vue